
import React from 'react';
const styles = {
  opacity: 0.1
}
const play = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="39" height="39" viewBox="0 0 39 39">
      <circle fill="#fff" style={styles} cx="19.5" cy="19.5" r="19.5" />
      <path fill="#fff" fillRule="evenodd" d="M14.67 25.72l1.035-1.01-4.6-4.5h20.432v-1.42h-20.437l4.6-4.5-1.035-1.01-6.372 6.22z" />
    </svg>


  );
};

export default play;


// WEBPACK FOOTER //
// ./src/components/svg-icons/BackArrowIcon.jsx